<template>
  <div class="star-list">
    <i class="fa fa-star star-fa" :class="{active: value > 0}" @click="clickStar(1)" aria-hidden="true"></i>
    <i class="fa fa-star star-fa " :class="{active: value > 1}" @click="clickStar(2)" aria-hidden="true"></i>
    <i class="fa fa-star star-fa " :class="{active: value > 2}" @click="clickStar(3)" aria-hidden="true"></i>
    <i class="fa fa-star star-fa " :class="{active: value > 3}" @click="clickStar(4)" aria-hidden="true"></i>
    <i class="fa fa-star star-fa " :class="{active: value > 4}" @click="clickStar(5)" aria-hidden="true"></i>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {}
  },
  methods: {
    clickStar (v) {
      this.$emit('change', v)
    }
  }
}
</script>
<style scoped lang="less">
  .star-list {
    cursor: pointer;
    text-align: center;
    i{
      font-size: 20px;
      margin-right: 10px;
      color: #000;
      opacity: 0.2;
      &.active{
        color: orange;
        opacity: 1;
      }
    }
  }
</style>
